import { render } from "./SubmitRequirementsDialog.vue?vue&type=template&id=0412b4ea&scoped=true"
import script from "./SubmitRequirementsDialog.vue?vue&type=script&lang=js"
export * from "./SubmitRequirementsDialog.vue?vue&type=script&lang=js"

import "./SubmitRequirementsDialog.vue?vue&type=style&index=0&id=0412b4ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0412b4ea"]])

export default __exports__